import * as types from './types';
import {
  ToolBookStatementProvidersListModel,//供应商列表
  ToolBookStatementProvidersCreateModel,//供应商创建编辑
  ToolBookStatementProvidersDeleteModel,//供应商删除
} from 'src/model/AdminModel';


export default{
  //供应商列表
  actionSupplierManageListPort({commit, state}, query){
    if (state.supplierManageList.state === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_SUPPLIER_MANAGE_LIST_PORT, {
      state: 'loading'
    });
    return ToolBookStatementProvidersListModel.getInstance().execute(query).then((response) => {
      commit(types.ACTION_SUPPLIER_MANAGE_LIST_PORT, {
        state: 'loadend',
        list: response.list,
        total : response.total
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_SUPPLIER_MANAGE_LIST_PORT, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
  //创建供应商
  actionCreateSupplierManageListPort(store,query){
    return ToolBookStatementProvidersCreateModel.getInstance().execute(query);
  },
  //供应商删除
  actionDeleteSupplierManageListPort(store,query){
    return ToolBookStatementProvidersDeleteModel.getInstance().execute(query);
  },

}






// WEBPACK FOOTER //
// ./src/store/Admin/modules/supplierManage/actions.js